import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/pwa/ico_apple.svg")